// BE-1121: screens scoped to the customer chosen in the toolbar each used to
// spell that out in their own words and their own styling. This is the shared
// version -- it lives in Common because the same red-text card is copied across
// the report screens too, and they should collapse onto this as they are
// touched rather than growing a copy each.
export default {
  name: "customer-scope-notice",
  props: {
    message: {
      type: String,
      default:
        "Choose a customer from the selector at the top of the page to see their data.",
    },
  },
};
